import './styles.scss';

import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';

import ActionSection from './components/actionSection';
import BackToTop from './components/backToTop';
import { FooterModel } from './models/footer.model';
import LinksSection from './components/linksSection';
import Navigation from './components/navigation';
import SocialMedia from './components/socialMedia';
import { TFooterProps } from './types/footer.types';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import Picture from '../@shared/picture';
import useSitecoreContext from '../../hooks/useSitecoreContext';

const Footer: FC<TFooterProps> = (props) => {
  const model = new FooterModel(props);
  const context = useSitecoreContext();
  const desktopLogoImage = context?.sitecoreContext?.defaultBackgroundImageParameters?.desktopImageData?.footerLogo;
  const mobileLogoImage = context?.sitecoreContext?.defaultBackgroundImageParameters?.mobileImageData?.footerLogo;

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <>
      {!model.hideSocialMedia && model?.socialLinks && <SocialMedia fields={model?.socialLinks} sitecoreContext={props?.sitecoreContext} />}
      <div className="footer">
        <div className="footer__container">
          <div className="footer__columns">
            {model?.actionSection && (
              <ActionSection sitecoreContext={props?.sitecoreContext} field={model?.actionSection} isBelow={false} />
            )}

            {model?.footerSections?.map((item) => (
              <LinksSection key={item?.id} fields={item?.fields?.footerLinks} />
            ))}

            {model?.actionSection && <ActionSection sitecoreContext={props?.sitecoreContext} field={model?.actionSection} isBelow={true} />}
          </div>
          <div className="footer__bottom">
            <div className="footer__text">
              <Navigation fields={model?.navigationSection} />
              {model?.copyrightText && <Text tag="p" field={model?.copyrightText} className="footer__copyright-text" />}
            </div>
            <Picture
              editorialImageProps={{
                desktopImage: desktopLogoImage,
                mobileImage: mobileLogoImage,
                desktopTransformation: 'Size200',
                mobileTransformation: 'Size200',
                cssClassImageEl: 'footer__logo',
              }}
            />
            {model?.backToTopText && <BackToTop field={model?.backToTopText} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default withSitecoreContext()(Footer);
